'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('lemon-db/dist/options/text.json');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var options = exports.options = _text2['default'];

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      UISmartCheckbox = _ref.UISmartCheckbox,
      TextEditor = _ref.TextEditor;

  var SmartCheckbox = function (_React$Component) {
    _inherits(SmartCheckbox, _React$Component);

    function SmartCheckbox() {
      _classCallCheck(this, SmartCheckbox);

      return _possibleConstructorReturn(this, (SmartCheckbox.__proto__ || Object.getPrototypeOf(SmartCheckbox)).apply(this, arguments));
    }

    _createClass(SmartCheckbox, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            name = _props.name,
            defaultChecked = _props.defaultChecked,
            checked = _props.checked,
            required = _props.required,
            value = _props.value,
            disabled = _props.disabled,
            position = _props.position,
            noInteraction = _props.noInteraction,
            align = _props.align,
            draft = _props.draft,
            theme = _props.theme,
            input = _props.input,
            rest = _objectWithoutProperties(_props, ['name', 'defaultChecked', 'checked', 'required', 'value', 'disabled', 'position', 'noInteraction', 'align', 'draft', 'theme', 'input']);

        return _react2['default'].createElement(UISmartCheckbox, _extends({
          name: name,
          defaultChecked: defaultChecked,
          checked: checked,
          value: value,
          disabled: disabled,
          position: position,
          noInteraction: noInteraction,
          valid: this.valid,
          optional: !required
        }, input, {
          textComponent: _react2['default'].createElement(TextEditor, _extends({}, rest, {
            align: align,
            draft: draft,
            theme: theme,
            color: '#0F0F0F'
          }))
        }));
      }
    }, {
      key: 'valid',
      get: function get() {
        var _props2 = this.props,
            meta = _props2.meta,
            required = _props2.required;

        if (meta && required) {
          return !meta.touched || !meta.error;
        } else if (meta && !required) {
          return !meta.dirty || !meta.error;
        }

        return true;
      }
    }]);

    return SmartCheckbox;
  }(_react2['default'].Component);

  SmartCheckbox.displayName = identifier;
  SmartCheckbox.themeShape = {};
  SmartCheckbox.propTypes = {
    name: _propTypes2['default'].string,
    defaultChecked: _propTypes2['default'].bool,
    checked: _propTypes2['default'].bool,
    onChange: _propTypes2['default'].func,
    value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].bool]),
    disabled: _propTypes2['default'].bool,
    position: _propTypes2['default'].oneOf(['default', 'start', 'end', 'lonely']),
    noInteraction: _propTypes2['default'].bool,
    valid: _propTypes2['default'].bool,
    align: _propTypes2['default'].oneOf(['left', 'center', 'right']),
    draft: _propTypes2['default'].shape({
      blocks: _propTypes2['default'].array.isRequired,
      entityMap: _propTypes2['default'].object.isRequired
    }).isRequired,
    theme: _propTypes2['default'].object,
    input: _propTypes2['default'].object,
    meta: _propTypes2['default'].object,
    required: _propTypes2['default'].bool
  };
  return SmartCheckbox;
};

exports['default'] = factory;